import pluralize from '@sravni/utils/lib/pluralize';

export const getYearsPluralize = (value: number) => pluralize(value, 'год', 'года', 'лет') ?? 'год';
